<template>
  <footer class="pts-footer">
    <div class="pts-container">
      <p>©2018-2019 Premium transport services. {{ $t('rights', 'Tous droits réservés.') }}</p>
      <div id="TA_socialButtonBubbles904" class="TA_socialButtonBubbles">
        <ul id="8BLVYk" class="TA_links M54xMdf2IE">
          <li id="BgQc1xr5" class="gTW5Qq3UyL4q">
            <a target="_blank" href="https://www.tripadvisor.fr/Attraction_Review-g13108905-d13082106-Reviews-Premium_Transport_Services-Mortcerf_Seine_et_Marne_Ile_de_France.html"><img src="https://www.tripadvisor.fr/img/cdsi/img2/branding/socialWidget/20x28_white-21693-2.png"/></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  mounted() {
    this.$polyglot.extendLocales({
      'fr': {
        'rights': 'Tous droits réservés.'
      },
      'en': {
        'rights': 'All rights reserved.'
      }
    })
  }
}
</script>

<style scoped>
.pts-footer {
  width: 100%;
  background: #464646;
  margin-top: -10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.pts-footer .pts-container {
  display: flex;
}

.pts-footer .pts-container p {
  color: #FFFFFF;
}

.pts-footer .pts-container div {
  margin-left: auto;
  margin-top: -5px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue